<hf-custom-pill iconType="image" imageSrc="/assets/external/verified-epc-badge.svg"
                label="Verified EPC"
                type="CUSTOM"
                backgroundColour="#ecfdf3"
                imageWidth="80px"
                imageHeight="17px"
                primaryColour="#067647"
                [customStyles]="{ 'border': '1px solid #ABEFC6' }"></hf-custom-pill>
<span [ngClass]="{
    'epc-expired': epcRatingExpired,
    'epc-valid': !epcRatingExpired}">
    {{ epcRatingExpired ? 'Expired ' : 'Valid until ' }}   {{ (epcDateValidUntil | date:'dd/MM/yy') }}
</span>
